import EpConfirmationTemplate from '../../../../../templates/EpConfirmationTemplate';

export default function Step6IncidentNotification() {
  return <EpConfirmationTemplate tag="PSNotificationSent" />;
}
